import { List, Spin, Dropdown } from "antd";
import { useEffect, useRef, useState } from "react";
import { BiRefresh } from "react-icons/bi";
import { CgSpinner } from "react-icons/cg";
import { FaCirclePlus } from "react-icons/fa6";
import { MdOutlineSystemSecurityUpdate } from "react-icons/md";
import { PiSealCheck } from "react-icons/pi";
import { TbDeviceRemote } from "react-icons/tb";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { showAlert } from "../../../Store/Actions/GeneralActions";
import { CusAssetsMiddleware } from "../../../Store/Middlewares/CusAssetsMiddleware";
import { CusModulesMiddleware } from "../../../Store/Middlewares/CusModulesMiddleware";
import assetsAssignImg from "../../../assets/images/car.png";
import dummyImg from "../../../assets/images/dummy.png";
import imagePlaceholder from "../../../assets/images/imageplace.jpg";
import image1 from "../../../assets/images/staticImages/md1.png";
import pf from "../../../assets/images/staticImages/pf.png";
import {
  InputField,
  Modal,
  SubmitButton,
  TextComponent,
} from "../../../components";
import BatteryStatus from "../../../components/battery/Battery";
import { extractBytes, hexToBase64 } from "../../../utills";
import { pusher } from "../../../utills/PusherHandler";
import AssetsAssign from "./AssetsAssign/AssetsAssign";
import styles from "./Module.module.css";
import Scheduling from "./Scheduling/Scheduling";
import SharedAccess from "./SharedAccess/SharedAccess";
import { AssetsMiddleware } from "../../../Store/Middlewares/AssetsMiddleware";
import AddAssets from "../../Dealership/AssetsManagement/AddAssets/AddAssets";

const Module = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const [isSelected, setIsSelected] = useState(1);
  const [loadingModal, setLoadingModal] = useState(false);
  const [isSuccessfulModal, setIsSuccessFulModal] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const [accessSharingModal, setAccessSharingModal] = useState(false);
  const [scheduleModal, setScheduleModal] = useState(false);
  const [assignAssetsModal, setAssignAssetsModal] = useState(false);
  const [addModule, setAddModule] = useState(false);
  const [device_name, setDevice_name] = useState("");
  const [device_id, setDevice_id] = useState("");
  const [details, setDetails] = useState();
  const [assetsSuccessModal, setAssetsSuccessModal] = useState(false);
  const [carStatus, setCarStatus] = useState(null);
  const [openAddAssetsModal, setOpenAddAssetsModal] = useState(false);

  const user = useSelector((state) => state.AuthReducer?.user);
  const MODULES = useSelector(
    (state) => state?.CusModulesReducer?.getCusModules,
  );
  const MODULE_DETAILS = useSelector(
    (state) => state?.CusModulesReducer?.modulesDetail,
  );
  const getCusUnlinkAssets = useSelector(
    (state) => state.CusAssetsReducer.getCusUnlinkAssets,
  );

  let car_status = [
    { id: 1, value: "New" },
    { id: 1, value: "Used" },
    { id: 1, value: "Loaner" },
    { id: 1, value: "Demo" },
  ];

  useEffect(() => {
    dispatch(CusModulesMiddleware.getCusModules({ name: "" }));
    dispatch(CusAssetsMiddleware.getCusUnlinkAssets()).then((data) => {});
  }, []);
  // console.log("MODULE_DETAILSMODULE_DETAILSMODULE_DETAILS", MODULE_DETAILS);

  const [checkBattery, setcheckBattery] = useState(false);
  const chatchannel = useRef();
  useEffect(() => {
    initiatePusher();
    return () => {
      if (chatchannel?.current) {
        chatchannel?.current?.unsubscribe();
      }
    };
  }, []);

  console.log(chatchannel.current, "chatchannel.currentchatchannel.current");

  const initiatePusher = () => {
    console.log("Pusher Initiated!");
    chatchannel.current = pusher.subscribe("phoenix-immobilizer");
    chatchannel.current.bind("App\\Events\\TTNUpLink", (data) => {
      console.log("data?.data?.ascii_payload", data);
      if (data?.data?.device_id == MODULE_DETAILS?.device_id) {
        if (data?.data?.ascii_payload?.includes("BV")) {
          const match = data?.data?.ascii_payload.match(/BV:([0-9.]+)/);
          const bvValue = match ? match[1] : null;
          dispatch(
            CusAssetsMiddleware.updateBatteryVolt({
              battery_volt: bvValue,
              asset_id: MODULE_DETAILS?.id,
            }),
          ).then(() => setcheckBattery(false));
        }
      }
    });
  };

  const getBatteryVolt = () => {
    setcheckBattery(true);
    dispatch(
      CusAssetsMiddleware.sentDownlinkBattery({
        device_id: MODULE_DETAILS?.device_id,
        action: hexToBase64(extractBytes(MODULE_DETAILS.dev_eui) + "A5"),
      }),
    ).then(() => {
      setcheckBattery(false);
    });
  };

  const onCreateModule = () => {
    let userData = {
      device_id,
      // device_name,
    };
    if (!device_id) {
      dispatch(
        showAlert({
          type: "Error",
          message: "Please enter Device id given by merchant!",
        }),
      );
    }
    //  else if (!device_name) {
    //   dispatch(
    //     showAlert({
    //       type: "Error",
    //       message: "Please enter Device Name",
    //     }),
    //   );
    // }
    else {
      dispatch(CusModulesMiddleware.createModule(userData)).then(() => {
        setAddModule(false);
      });
    }
  };

  const dummySharedAccess = [
    {
      id: 1,
      email: "patricia651@outlook.com",
    },
    {
      id: 2,
      image: pf,
      email: "patricia651@outlook.com",
    },
  ];
  const dummySchedule = [
    {
      id: 1,
      name: "Immobilizer Activation",
      day: "Daily",
      time: "10:00 PM",
    },
    {
      id: 2,
      name: "High Security mode",
      day: "Daily",
      time: "10:00 PM",
    },
    {
      id: 3,
      name: "Immobilizer Health Check",
      day: "Monday",
      time: "08:00 AM",
    },
  ];

  const loadingUpdateHandler = () => {
    setLoadingModal(true);
    setTimeout(() => {
      setLoadingModal(false);
      setIsSuccessFulModal(true);
    }, 2000);
  };
  const renderModules = (item, index) => {
    return (
      <div
        className={styles.listItem}
        onClick={() => {
          if (MODULE_DETAILS?.id != item?.id) {
            dispatch(CusModulesMiddleware.getModuleDetails({ id: item?.id }));
          }
        }}
        style={{
          border:
            MODULE_DETAILS?.id == item?.id
              ? "1px solid var(--secondary-color)"
              : "1px solid var(--border-color)",
        }}
      >
        <div className={styles.subListItem}>
          <img src={item?.image ? item?.image : image1} />
          <div className={styles.listItemContent}>
            {/* <TextComponent
              text={item?.device_name ? item?.device_name : "--"}
              style={{ fontFamily: "Urbanist-bold" }}
            /> */}
            <TextComponent
              text={"LoRaWAN Version: "}
              style={{ fontSize: "13px" }}
            >
              <text style={{ fontFamily: "Urbanist-semibold" }}>1.0.3</text>
            </TextComponent>
            {item?.name && (
              <TextComponent
                style={{ fontSize: "13px" }}
                text={`Name: ${item?.name ? item?.name : "--"}`}
              />
            )}
            {item?.make && (
              <TextComponent
                style={{ fontSize: "13px" }}
                text={`Make: ${item?.make ? item?.make : "--"}`}
              />
            )}
            {item?.model && (
              <TextComponent
                style={{ fontSize: "13px" }}
                text={`Model: ${item?.model ? item?.model : "--"}`}
              />
            )}
            {item?.vin_no && (
              <TextComponent
                style={{ fontSize: "13px" }}
                text={`VIN: ${item?.vin_no ? item?.vin_no : "--"}`}
              />
            )}
            {/* <TextComponent
              text={`vehicle: ${item?.make ? item?.make : "--"} ${
                item?.model ? item?.model : "--"
              }`}
              style={{ fontSize: "13px" }}
            /> */}
            <TextComponent
              text={`Device ID: ${item?.device_id ? item?.device_id : "--"}`}
              style={{ fontSize: "13px" }}
            />
          </div>
        </div>
        {/* {item?.shared_by && (
          <TextComponent
            text={`Access shared by: ${item?.shared_by}`}
            style={{ fontSize: "var(--mobile-sub-heading)", marginTop: "5px" }}
          />
        )} */}
      </div>
    );
  };
  return (
    <div className={styles.mainCont}>
      <div className={styles.subCont}>
        <div className={styles.header}>
          <TextComponent
            text={"Devices"}
            style={{
              fontSize: "var(--heading2-font-size)",
              fontFamily: "Urbanist-bold",
            }}
          />
          {/* <SubmitButton
            onClick={() => setAddModule(true)}
            btnClass={styles.headerBtn}
            title={"Add Device"}
            rightIcon={
              <FaCirclePlus
                size={15}
                color="var(--white-color)"
                style={{ marginLeft: "5px" }}
              />
            }
          /> */}
        </div>
        <div className={styles.listCont}>
          <List
            dataSource={MODULES}
            renderItem={renderModules}
            className={styles.list}
          />
        </div>
      </div>
      {MODULE_DETAILS && (
        <div className={styles.subContRight}>
          <div className={styles.subContChild}>
            <img
              src={MODULE_DETAILS?.image ? MODULE_DETAILS?.image : image1}
              className={styles.rightImg}
            />
            <div className={styles.right_name}>
              <TextComponent
                text={
                  MODULE_DETAILS?.device_id ? MODULE_DETAILS?.device_id : "--"
                }
                style={{
                  fontFamily: "Urbanist-bold",
                  fontSize: "var(--paragraph-font-size)",
                }}
              />
              {/* <div className={styles.listSwitch}>
              <TextComponent
                text={details?.status}
                style={{
                  fontSize: "var(--mobile-heading)",
                  marginRight: "10px",
                }}
              />
              <Switch
                disabled
                isChecked={details?.status == "Immobilized" ? true : false}
                // value={isVerificationOn}
                activeColor={"var(--primary-color)"}
                inactiveColor={"var(--green-color)"}
                size="small"
              />
            </div> */}
            </div>
            <TextComponent
              text={"Connected via LoRaWAN"}
              style={{
                fontSize: "var(--mobile-heading)",
                marginTop: "20px",
              }}
            />
            {/* <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <BatteryStatus
                percentage={parseFloat(
                  MODULE_DETAILS?.battery_volt
                    ? (MODULE_DETAILS?.battery_volt / 12) * 100
                    : (12 / 12) * 100,
                ).toFixed(0)}
              />
              <div style={{ marginLeft: "10px" }}>
                {checkBattery ? (
                  <Spin
                    size="small"
                    style={{ color: "var(--secondary-color)" }}
                  />
                ) : (
                  <BiRefresh
                    size={20}
                    style={{ cursor: "pointer" }}
                    onClick={getBatteryVolt}
                  />
                )}
              </div>
            </div> */}

            <div className={styles.right_name}>
              <TextComponent
                text={"LoRaWAN Version: "}
                style={{
                  fontSize: "var(--mobile-heading)",
                }}
              >
                {" "}
                <text style={{ fontFamily: "Urbanist-semibold" }}>
                  {"1.0.3"}
                </text>
              </TextComponent>
            </div>
            <div className={styles.drawerCarDiv}>
              {MODULE_DETAILS?.asset_id != null ? (
                <>
                  <div className={styles.drawerCarDivLeft}>
                    <img
                      src={
                        MODULE_DETAILS?.image
                          ? MODULE_DETAILS?.image
                          : imagePlaceholder
                      }
                      className={styles.drawerCarImg}
                    />
                    <div>
                      <div
                        style={{
                          display: "flex",
                          gap: "5px",
                          flexDirection: "column",
                        }}
                      >
                        {MODULE_DETAILS?.name && (
                          <TextComponent
                            style={{ fontFamily: "Urbanist-bold" }}
                            text={`Name: ${MODULE_DETAILS?.name ? MODULE_DETAILS?.name : "--"}`}
                          />
                        )}
                        {MODULE_DETAILS?.make && (
                          <TextComponent
                            style={{ fontFamily: "Urbanist-bold" }}
                            text={`Make: ${MODULE_DETAILS?.make ? MODULE_DETAILS?.make : "--"}`}
                          />
                        )}
                        {MODULE_DETAILS?.model && (
                          <TextComponent
                            style={{ fontFamily: "Urbanist-bold" }}
                            text={`Model: ${MODULE_DETAILS?.model ? MODULE_DETAILS?.model : "--"}`}
                          />
                        )}
                        {MODULE_DETAILS?.vin_no && (
                          <TextComponent
                            style={{ fontFamily: "Urbanist-bold" }}
                            text={`VIN: ${
                              MODULE_DETAILS?.vin_no
                                ? MODULE_DETAILS?.vin_no
                                : "--"
                            }`}
                          />
                        )}
                      </div>

                      {/* <div style={{ width: "50%" }}> */}
                      <Dropdown
                        value={
                          MODULE_DETAILS?.shared_access
                            ? "Sold"
                            : MODULE_DETAILS?.car_status
                              ? MODULE_DETAILS?.car_status
                              : "--"
                        }
                        inputClass={styles.drawerCarText}
                        options={car_status}
                        onChange={(e) => {
                          setCarStatus(e);
                          dispatch(
                            AssetsMiddleware.updateCarStatus({
                              id: MODULE_DETAILS?.id,
                              carStatus: e?.value,
                            }),
                          );
                        }}
                        disabled={MODULE_DETAILS?.shared_access}
                      />
                      {/* </div> */}
                    </div>
                  </div>
                  {/* <div className={styles.drawerCarDivRight}>
                <HiOutlineDotsVertical
                  color={"var(--input-icon)"}
                  size={20}
                  style={{ cursor: "pointer" }}
                />
                <FiArrowRightCircle
                  color={"var(--secondary-color)"}
                  size={25}
                  style={{ cursor: "pointer", marginTop: "10px" }}
                />
              </div> */}
                </>
              ) : (
                <div
                  className={styles.emptyAssets}
                  onClick={() => setAssignAssetsModal(true)}
                >
                  <FaCirclePlus
                    size={18}
                    color="var(--secondary-color)"
                    style={{ marginRight: "5px" }}
                  />
                  <TextComponent
                    text={"Assign Vehicle"}
                    style={{
                      color: "var(--secondary-color)",
                      fontFamily: "Urbanist-bold",
                    }}
                  />
                </div>
              )}
            </div>
          </div>
          {MODULE_DETAILS?.asset_id && (
            <>
              {/* <div className={styles.subContChild}> */}
              {/* <div className={styles.myCarDiv}>
                  <TextComponent
                    text={`${MODULE_DETAILS?.name ? MODULE_DETAILS?.name : "--"} - ${MODULE_DETAILS?.make ? MODULE_DETAILS?.make : "--"} ${MODULE_DETAILS?.model ? MODULE_DETAILS?.model : "--"}`}
                    style={{
                      fontFamily: "Urbanist-bold",
                      fontSize: "var(--dashboard_tabs-font-size)",
                    }}
                  /> */}
              {/* <TextComponent
                    onClick={() => navigate("/userAssets")}
                    text={"View details"}
                    style={{
                      fontFamily: "Urbanist-semibold",
                      fontSize: "var(--mobile-sub-heading)",
                      color: "var(--primary-color)",
                      textDecoration: "underline",
                      cursor: "pointer",
                    }}
                  /> */}
              {/* </div> */}

              {/* ) : (
            <div>
              <TextComponent
                text={"Assets"}
                style={{
                  fontFamily: "Urbanist-bold",
                  fontSize: "var(--paragraph-font-size)",
                }}
              />
              <div
                className={styles.emptyAssets}
                onClick={() => setAssignAssetsModal(true)}
              >
                <FaCirclePlus
                  size={18}
                  color="var(--secondary-color)"
                  style={{ marginRight: "5px" }}
                />
                <TextComponent
                  text={"Assign Assets"}
                  style={{
                    color: "var(--secondary-color)",
                    fontFamily: "Urbanist-bold",
                  }}
                />
              </div>
            </div>
          )} */}
              {/* </div> */}
              {/* {MODULE_DETAILS?.asset_id && (
                <div className={styles.subContChild}>
                  <TextComponent
                    style={{
                      fontFamily: "Urbanist-bold",
                      fontSize: "var(--paragraph-font-size)",
                    }}
                    text={"Access details"}
                  />
                  <div className={styles.Access_Owner}>
                    <TextComponent
                      style={{ color: "var( --light-text)" }}
                      text={`Owner: ${
                        MODULE_DETAILS?.owner_id == user?.id
                          ? "You"
                          : MODULE_DETAILS?.owner_name
                      }`}
                    />
                    {MODULE_DETAILS?.owner_id == user?.id && (
                      <TextComponent
                        onClick={() => setAccessSharingModal(true)}
                        className={styles.access_sharedBtn}
                        text={"Share Access"}
                      />
                    )}
                  </div>
                  {MODULE_DETAILS?.owner_id == user?.id && (
                    <TextComponent
                      style={{
                        fontFamily: "Urbanist-semibold",
                        fontSize: "var(--mobile-sub-heading)",
                      }}
                      text={"Shared access"}
                    />
                  )}

                  {MODULE_DETAILS?.owner_id == user?.id && (
                    <List
                      className={styles.access_list}
                      dataSource={MODULE_DETAILS?.shared_access}
                      renderItem={(item, index) => (
                        <div key={index} className={styles.access_listItem}>
                          <div className={styles.access_listLeft}>
                            <img src={item?.image ? item?.image : dummyImg} />
                            <TextComponent
                              style={{
                                fontSize: "var(--mobile-sub-heading)",
                                fontFamily: "Urbanist-semibold",
                              }}
                              text={item.email}
                            />
                          </div>
                          <div
                            className={styles.access_remove}
                            onClick={() => {
                              dispatch(
                                CusModulesMiddleware.removeAccess({
                                  asset_id: MODULE_DETAILS?.asset_id,
                                  user_id: item?.id,
                                }),
                              );
                            }}
                          >
                            <TextComponent text={"Remove"} />
                          </div>
                        </div>
                      )}
                    />
                  )}
                </div>
              )} */}
            </>
          )}
          {/* <div className={styles.subContChild}>
            <div className={styles.schedule_header}>
              <TextComponent
                style={{
                  fontFamily: "Urbanist-bold",
                  fontSize: "var(--paragraph-font-size)",
                }}
                text={"Schedule"}
              />
              <div
                className={styles.schedule_addBtn}
                onClick={() => setScheduleModal(true)}
              >
                <TextComponent text={"Add"} />
                <HiMiniPlusCircle
                  color={"var(--primary-color)"}
                  style={{ marginLeft: "5px" }}
                />
              </div>
            </div>
            <List
              dataSource={dummySchedule}
              renderItem={(item, index) => (
                <div key={index} className={styles.schedule_listItem}>
                  <div className={styles.schedule_listheader}>
                    <TextComponent
                      text={item?.name}
                      style={{ fontFamily: "Urbanist-semibold" }}
                    />
                    <HiOutlineDotsVertical
                      color={"var(--input-icon)"}
                      size={15}
                      style={{ cursor: "pointer" }}
                    />
                  </div>
                  <div className={styles.schedule_listDateTime}>
                    <TextComponent
                      text={`${item?.day} `}
                      style={{
                        color: "var(--light-text)",
                        fontSize: "var(--mobile-sub-heading)",
                      }}
                    />
                    <TextComponent
                      text={item?.time}
                      style={{
                        fontSize: "var(--mobile-sub-heading)",
                        marginRight: "10px",
                      }}
                    />
                    <Switch
                      disabled
                      // isChecked={item?.status == "Immobilized" ? true : false}
                      // value={isVerificationOn}
                      activeColor={"var(--light-grey)"}
                      inactiveColor={"var(--green-color)"}
                      // onChange={() => setIsVerificationOn(!isVerificationOn)}
                      size="small"
                    />
                  </div>
                </div>
              )}
            />
          </div> */}
        </div>
      )}
      <Modal
        width={"400px"}
        open={loadingModal}
        closable={false}
        title={"Checking for updates"}
        icon={
          <CgSpinner
            color={"var(--secondary-color)"}
            style={{ width: "100%", height: "100%" }}
          />
        }
      ></Modal>
      <Modal
        open={isSuccessfulModal}
        onCancel={() => setIsSuccessFulModal(false)}
        icon={
          <PiSealCheck
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        title={"Your system is up to date"}
        headingClass={styles.modalHeading}
        width={"400px"}
        buttonTitle={"Continue"}
        onBtnPress={() => {
          setIsSuccessFulModal(false);
          setUpdateModal(true);
        }}
      ></Modal>
      <Modal
        open={updateModal}
        onCancel={() => setUpdateModal(false)}
        icon={
          <MdOutlineSystemSecurityUpdate
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        title={"New update Available"}
        headingClass={styles.modalHeading}
        width={"400px"}
        // buttonTitle={"Continue"}
        // onBtnPress={() => {setUpdateModal(false); setIsSuccessFulModal(true)}}
      >
        <SubmitButton
          title={"Update"}
          style={{ width: "90%" }}
          onClick={() => {
            setUpdateModal(false);
            setIsSuccessFulModal(true);
          }}
        />
      </Modal>
      <SharedAccess
        accessSharingModal={accessSharingModal}
        setAccessSharingModal={setAccessSharingModal}
      />
      <Scheduling
        scheduleModal={scheduleModal}
        setScheduleModal={setScheduleModal}
      />
      <AssetsAssign
        assignAssetsModal={assignAssetsModal}
        setAssignAssetsModal={setAssignAssetsModal}
      />
      <AddAssets
        from={"customer"}
        isOpen={openAddAssetsModal}
        setIsOpen={setOpenAddAssetsModal}
      />
      <Modal
        open={addModule}
        onCancel={() => setAddModule(false)}
        icon={<TbDeviceRemote size={100} />}
        title={"Create Device"}
        width={"800px"}
        twoButton
        okBtnTitle={"Create"}
        cancelBtnTitle={"Go back"}
        btnDiv={styles.access_modalBtn}
        onClickCancelButton={() => {
          setAddModule(false);
        }}
        onClickOkButton={onCreateModule}
        btnStyle={{ width: "80%" }}
      >
        <div className={styles.modalCont}>
          {/* <InputField
            label={"Device Name"}
            placeholder={"Write here"}
            value={device_name}
            onChange={(e) => setDevice_name(e.target.value)}
          /> */}
          <InputField
            label={"Device ID (Case Sensitive)"}
            placeholder={"Write here"}
            value={device_id}
            onChange={(e) => setDevice_id(e.target.value)}
          />
        </div>
      </Modal>
      {/* /////////////////////////Asset Assigned Modal///////////////////////// */}
      <Modal
        open={assignAssetsModal}
        onCancel={() => setAssignAssetsModal(false)}
        imageClass={styles.assignAssetsImgStyle}
        icon={
          <img
            src={assetsAssignImg}
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        width={"600px"}
        twoButton
        okBtnTitle={"Add new vehicle"}
        cancelBtnTitle={"Go Back"}
        leftBtnIcon={
          <FaCirclePlus
            size={15}
            color="var(--white-color)"
            style={{ marginRight: "5px" }}
          />
        }
        btnDiv={styles.access_modalBtn}
        onClickCancelButton={() => {
          setAssignAssetsModal(false);
        }}
        onClickOkButton={() => {
          setAssignAssetsModal(false);
          setOpenAddAssetsModal(true);
        }}
        headingClass={styles.modalHeading}
      >
        <>
          <TextComponent
            text={"Assign Vehicle"}
            style={{
              fontFamily: "Urbanist-bold",
              fontSize: "var(--heading2-font-size)",
            }}
          />
          <div className={styles.assetsCont}>
            <List
              dataSource={getCusUnlinkAssets}
              renderItem={(item, index) => (
                <div className={styles.assetsItemDiv} key={index}>
                  {" "}
                  <div className={styles.assetslistItem} key={index}>
                    <div className={styles.assetsImgDiv}>
                      <img src={item?.image ? item?.image : imagePlaceholder} />
                      <div className={styles.assetslistText}>
                        {/* <div className={styles.assetslistTextTop}> */}
                        <TextComponent
                          text={`Model: ${item?.model ? item?.model : "--"}`}
                          style={{
                            fontFamily: "Urbanist-bold",
                            fontSize: "var(--mobile-heading)",
                          }}
                        />
                        <TextComponent
                          text={`Make: ${item?.make ? item?.make : "--"}`}
                          style={{
                            fontFamily: "Urbanist-bold",
                            fontSize: "var(--mobile-heading)",
                          }}
                        />
                        {/* </div> */}
                        {/* <div className={styles.assetslistTextTop}> */}
                        <TextComponent
                          text={`VIN: ${item?.vin_no ? item?.vin_no?.toString().slice(-8) : "--"}`}
                          style={{
                            fontFamily: "Urbanist-bold",
                            fontSize: "var(--mobile-heading)",
                          }}
                        />
                        <TextComponent
                          text={`Stock No: ${item?.stock_no ? item?.stock_no : "--"}`}
                          style={{
                            fontFamily: "Urbanist-bold",
                            fontSize: "var(--mobile-heading)",
                          }}
                        />
                        {/* </div> */}
                      </div>
                    </div>
                  </div>
                  <SubmitButton
                    secondaryBtn
                    title={"Assign"}
                    style={{ marginTop: "10px" }}
                    onClick={() => {
                      dispatch(
                        CusAssetsMiddleware.cusAssignAsset({
                          assetId: item?.id,
                          deviceId: MODULE_DETAILS?.device_id,
                        }),
                      ).then(() => {
                        setAssetsSuccessModal(true);
                        setAssignAssetsModal(false);
                        // setOpen(false);
                        setDetails([]);
                      });
                    }}
                  />
                </div>
              )}
            />
          </div>
        </>
      </Modal>
      ;
      {/* /////////////////////////Asset Assigned Successfull///////////////////////// */}
      <Modal
        open={assetsSuccessModal}
        onCancel={() => setAssetsSuccessModal(false)}
        icon={
          <PiSealCheck
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        title={"Asset Assigned successfully"}
        width={"400px"}
        buttonTitle={"Continue"}
        onBtnPress={() => {
          setAssetsSuccessModal(false);
        }}
        headingClass={styles.modalHeading}
      >
        {" "}
      </Modal>
    </div>
  );
};

export default Module;
